import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SaidaEstoqueListarRoutingModule } from './saida-estoque-listar-routing.module';
import { SaidaEstoqueListarComponent } from './saida-estoque-listar.component';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { ConfirmationService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import {SplitButtonModule} from 'primeng/splitbutton';
import {SelectButtonModule} from 'primeng/selectbutton';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  declarations: [
    SaidaEstoqueListarComponent
  ],
  imports: [
    CommonModule,
    SaidaEstoqueListarRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    DividerModule,
    MessagesModule,
    TooltipModule,
    CalendarModule,
    SplitButtonModule,
    SelectButtonModule,
    DropdownModule

  ],
  providers: [ConfirmationService]
})
export class SaidaEstoqueListarModule { }
